import React from 'react';
import { Link } from 'react-router-dom';

const CardButton = ({ username, showTooltip, hideTooltip }) => {
  return (
    <Link
      to={`/profile/${username}`}
      className="user-card-button"
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={() => showTooltip('Профиль', 'Открыть профиль', username)}
      onMouseLeave={hideTooltip}
    >
      →
    </Link>
  );
};

export default CardButton;